import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MomentDateAdapter,
  MomentDateModule,
} from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatNativeDateModule,
  MatOptionModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EllipsisModule } from 'ngx-ellipsis';
import { PaginatorI18n } from 'src/app/utils/custom-mat-paginator-int';
import { DirectivesModule } from '../directives/directives.module';
import { appDateFormat } from '../model/input-custom/input-custom.interface';
import { ActionButtonsComponent } from './action-buttons/action-buttons.component';
import { AutoCompleteChecksComponent } from './auto-complete-checks/auto-complete-checks.component';
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';
import { BreadcrumbBarComponent } from './breadcrumb-bar/breadcrumb-bar.component';
import { CarouselCheckGroupsComponent } from './carousel-check-groups/carousel-check-groups.component';
import { ChartComponent } from './chart/chart.component';
import { CommentUserComponent } from './comment-user/comment-user.component';
import { HeaderComponent } from './header/header.component';
import { IndicatorStatusComponent } from './indicator-status/indicator-status.component';
import { AutoCompleteReactiveComponent } from './input-custom/auto-complete-reactive/auto-complete-reactive.component';
import { InputCustomComponent } from './input-custom/input-custom.component';
import { InputSearchBarComponent } from './input-search-bar/input-search-bar.component';
import { LoadingComponent } from './loading/loading.component';
import { ModalAlertComponent } from './modal-alert/modal-alert.component';
import { ModalNotificationsComponent } from './modal-notifications/modal-notifications.component';
import { ModalProgressComponent } from './modal-progress/modal-progress.component';
import { ModalUploadComponent } from './modal-upload/modal-upload.component';
import { ProgressComponent } from './modal-upload/progress/progress.component';
import { ModalUrlDocComponent } from './modal-url-doc/modal-url-doc.component';
import { NotificationItemComponent } from './notification-item/notification-item.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { SelectComponent } from './select/select.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { StatusProcessComponent } from './status-process/status-process.component';
import { TableComponent } from './table/table.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import {
  CalendarModule,
  DateAdapter as DateAngularCalendar,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxColorsModule } from 'ngx-colors';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { QuillModule } from 'ngx-quill';
import Counter from '../counter';
import { PipesModule } from '../pipes/pipes.module';
import { AutoCompleteChecksNotSelectComponent } from './auto-complete-checks-not-select/auto-complete-checks-not-select.component';
import { AutoCompleteChecksOptimComponent } from './auto-complete-checks-optim/auto-complete-checks-optim.component';
import { CollapseFormComponent } from './collapse-form/collapse-form.component';
import { CopyComponent } from './copy/copy.component';
import { ChangeIconComponent } from './event-collapse/change-icon/change-icon.component';
import { EventCollapseComponent } from './event-collapse/event-collapse.component';
import { ViewUrlComponent } from './event-collapse/view-url/view-url.component';
import { IndicatorInputComponent } from './indicator-input/indicator-input.component';
import { AutocompleteStringComponent } from './input-custom/autocomplete-string/autocomplete-string.component';
import { CheckBoxComponent } from './input-custom/check-box/check-box.component';
import { ColorPickerComponent } from './input-custom/color-picker/color-picker.component';
import { CopyInputComponent } from './input-custom/copy-input/copy-input.component';
import { DateCustomComponent } from './input-custom/date-custom/date-custom.component';
import { DatePickerCustomComponent } from './input-custom/date-picker-custom/date-picker-custom.component';
import { InputTextComponent } from './input-custom/input-text/input-text.component';
import { MultiselectCustomComponent } from './input-custom/multiselect-custom/multiselect-custom.component';
import { MultiselectOptimizedComponent } from './input-custom/multiselect-optimized/multiselect-optimized.component';
import { NumberPlusAndLessComponent } from './input-custom/number-plus-and-less/number-plus-and-less.component';
import { NumberCompactComponent } from './input-custom/number-compact/number-compact.component';
import { PercentageComponent } from './input-custom/percentage/percentage.component';
import { RadioCustomComponent } from './input-custom/radio-custom/radio-custom.component';
import { SelectCustomComponent } from './input-custom/select-custom/select-custom.component';
import { TextareaComponent } from './input-custom/textarea/textarea.component';
import { ToogleCustomComponent } from './input-custom/toogle-custom/toogle-custom.component';
import { UploadCustomComponent } from './input-custom/upload-custom/upload-custom.component';
import { UploadDragDropComponent } from './input-custom/upload-drag-drop/upload-drag-drop.component';
import { UploadImagesComponent } from './input-custom/upload-images/upload-images.component';
import { UploadIndividualBtnComponent } from './input-custom/upload-individual-btn/upload-individual-btn.component';
import { YearPickerComponent } from './input-custom/year-picker/year-picker.component';
import { ModalActionButtonsComponent } from './modal-action-buttons/modal-action-buttons.component';
import { MultiselectChipsComponent } from './multiselect-chips/multiselect-chips.component';
import { SearchDocsCollapseComponent } from './search-docs-collapse/search-docs-collapse.component';
import { SearchFilesComponent } from './search-files/search-files.component';
import { SearchStudentsTableComponent } from './search-students-table/search-students-table.component';
import { SearchUsersTableComponent } from './search-users-table/search-users-table.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { ViewEditorComponent } from './view-editor/view-editor.component';
import { DateChangeButtonsComponent } from './year-calendar/components/date-change-buttons/date-change-buttons.component';
import { DateRangePickerComponent } from './year-calendar/components/date-range-picker/date-range-picker.component';
import { TimeCalendarComponent } from './year-calendar/components/time-calendar/time-calendar.component';
import { YearCalendarComponent } from './year-calendar/year-calendar.component';
import { InputSearchBarBasicComponent } from './input-search-bar-basic/input-search-bar-basic.component';
import { TreeChecksComponent } from './tree-checks/tree-checks.component';
import { CustomAlertComponent } from './custom-alert/custom-alert.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { SelectValueCustomComponent } from './select-value-custom/select-value-custom.component';
import { SimpleDragDropComponent } from './simple-drag-drop/simple-drag-drop.component';
import { TextRichCustomComponent } from './input-custom/text-rich-custom/text-rich-custom.component';
import { A11yModule } from "@angular/cdk/a11y";
import { LaureateButtonComponent } from './laureate-button/laureate-button.component';
import { SimpleSkeletonComponent } from './simple-skeleton/simple-skeleton.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CustomPdfViewerComponent } from './custom-pdf-viewer/custom-pdf-viewer.component';
import { SelectableRadioModule } from './selectable-radio/selectable-radio.module';
import { InformationItemModule } from './information-item/information-item.module';
import { ToggleCardModule } from './toggle-card/toogle-card.module';
import { SectionTitleComponent } from './section-title/section-title.component';
import { AlertEmptyInfoComponent } from './ alert-empty-info/ alert-empty-info.component';
import { TableHierarchyComponent } from './table-hierarchy/table-hierarchy.component';

@NgModule({
  declarations: [
    ChartComponent,
    HeaderComponent,
    SideMenuComponent,
    InputSearchBarComponent,
    BreadcrumbBarComponent,
    TableComponent,
    AutoCompleteComponent,
    ActionButtonsComponent,
    PaginatorComponent,
    ModalAlertComponent,
    ModalUploadComponent,
    ProgressComponent,
    AutoCompleteChecksComponent,
    CarouselCheckGroupsComponent,
    SelectComponent,
    LoadingComponent,
    SnackbarComponent,
    InputCustomComponent,
    ProgressComponent,
    ModalProgressComponent,
    AutoCompleteReactiveComponent,
    IndicatorStatusComponent,
    CommentUserComponent,
    StatusProcessComponent,
    NotificationItemComponent,
    ModalNotificationsComponent,
    SearchUsersTableComponent,
    NumberPlusAndLessComponent,
    NumberCompactComponent,
    CollapseFormComponent,
    SearchDocsCollapseComponent,
    ModalUrlDocComponent,
    AutoCompleteChecksOptimComponent,
    ColorPickerComponent,
    EventCollapseComponent,
    ViewUrlComponent,
    YearCalendarComponent,
    ChangeIconComponent,
    YearPickerComponent,
    DatePickerCustomComponent,
    DateRangePickerComponent,
    DateChangeButtonsComponent,
    TimeCalendarComponent,
    ModalActionButtonsComponent,
    PercentageComponent,
    CopyComponent,
    CopyInputComponent,
    TextareaComponent,
    MultiselectOptimizedComponent,
    AutoCompleteChecksNotSelectComponent,
    CheckBoxComponent,
    SearchStudentsTableComponent,
    TextEditorComponent,
    ViewEditorComponent,
    MultiselectChipsComponent,
    InputTextComponent,
    SelectCustomComponent,
    MultiselectCustomComponent,
    DateCustomComponent,
    UploadCustomComponent,
    UploadIndividualBtnComponent,
    UploadDragDropComponent,
    ToogleCustomComponent,
    RadioCustomComponent,
    AutocompleteStringComponent,
    IndicatorInputComponent,
    UploadImagesComponent,
    SearchFilesComponent,
    InputSearchBarBasicComponent,
    TreeChecksComponent,
    CustomAlertComponent,
    MultiselectComponent,
    SelectValueCustomComponent,
    SimpleDragDropComponent,
    TextRichCustomComponent,
    LaureateButtonComponent,
    SimpleSkeletonComponent,
    CustomPdfViewerComponent,
    SectionTitleComponent,
    AlertEmptyInfoComponent,
    TableHierarchyComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatTreeModule,
    NgApexchartsModule,
    MatOptionModule,
    MatAutocompleteModule,
    TranslateModule.forChild({
      extend: true,
    }),
    MatSlideToggleModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatSliderModule,
    CdkTableModule,
    MatCheckboxModule,
    MatSortModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    EllipsisModule,
    MatRadioModule,
    MatTooltipModule,
    ScrollingModule,
    DirectivesModule,
    MatExpansionModule,
    MomentDateModule,
    ClipboardModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    NgxColorsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    InfiniteScrollModule,
    CalendarModule.forRoot({
      provide: DateAngularCalendar,
      useFactory: adapterFactory,
    }),
    MatButtonToggleModule,
    ReactiveFormsModule,
    QuillModule.forRoot({
      customModules: [
        {
          implementation: Counter,
          path: 'modules/counter',
        },
      ],
    }),
    PipesModule,
    MatProgressBarModule,
    MatChipsModule,
    A11yModule,
    PdfViewerModule,
    SelectableRadioModule,
    InformationItemModule,
    ToggleCardModule
  ],
  exports: [
    ChartComponent,
    HeaderComponent,
    SideMenuComponent,
    InputSearchBarComponent,
    BreadcrumbBarComponent,
    TableComponent,
    AutoCompleteComponent,
    ActionButtonsComponent,
    PaginatorComponent,
    ModalAlertComponent,
    AutoCompleteChecksComponent,
    CarouselCheckGroupsComponent,
    LoadingComponent,
    InputCustomComponent,
    ModalProgressComponent,
    AutoCompleteReactiveComponent,
    IndicatorStatusComponent,
    CommentUserComponent,
    NotificationItemComponent,
    SearchUsersTableComponent,
    CollapseFormComponent,
    SearchDocsCollapseComponent,
    AutoCompleteChecksOptimComponent,
    EventCollapseComponent,
    YearCalendarComponent,
    DateRangePickerComponent,
    TimeCalendarComponent,
    DateChangeButtonsComponent,
    CopyComponent,
    AutoCompleteChecksNotSelectComponent,
    SearchStudentsTableComponent,
    TextEditorComponent,
    MultiselectChipsComponent,
    IndicatorInputComponent,
    SearchFilesComponent,
    ViewEditorComponent,
    InputSearchBarBasicComponent,
    TreeChecksComponent,
    CustomAlertComponent,
    MultiselectComponent,
    SelectValueCustomComponent,
    SimpleDragDropComponent,
    LaureateButtonComponent,
    SimpleSkeletonComponent,
    CustomPdfViewerComponent,
    InformationItemModule,
    SelectableRadioModule,
    ToggleCardModule,
    SectionTitleComponent,
    AlertEmptyInfoComponent,
    TableHierarchyComponent
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) =>
        new PaginatorI18n(translateService).getPaginatorIntl(),
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: appDateFormat,
    },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    DatePipe,
  ],
})
export class ComponentsModule { }
